import React from "react";
import { ReactComponent as Sorm } from "assets/images/logo.svg";
import { ReactComponent as SormWhite } from "assets/images/logowhite.svg";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const location = useLocation();
  const isTestPage = location.pathname === "/test" || location.pathname === "/";

  return (
    <header className={`header__wrapper ${isTestPage ? "header__wrapper--transparent" : ""}`}>
      <div className="logo">
        <Link to="/">
          {isTestPage ? <SormWhite className="logo" /> : <Sorm className="logo" />}
        </Link>
      </div>
    </header>
  );
};

export default Header;
